var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgObjectives(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-120 -460)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "bg",
    cx: 52,
    cy: 52,
    r: 52,
    transform: "translate(120 460)",
    fill: "#263a4b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Layer_2",
    "data-name": "Layer 2",
    d: "M49.931,10.167A1.712,1.712,0,0,0,48.8,8.936L44.481,7.494,43.038,3.171A1.712,1.712,0,0,0,40.2,2.5L34.7,8a22.3,22.3,0,1,0,9.263,9.277l5.508-5.508A1.712,1.712,0,0,0,49.931,10.167ZM24.293,46.516a18.834,18.834,0,1,1,8.626-35.538c.01.041.01.082.024.123l1.37,4.133-2.856,2.859a12.033,12.033,0,1,0,2.424,2.424l2.863-2.863,4.133,1.37c.036.012.075.009.113.019a18.76,18.76,0,0,1-16.7,27.472Zm8.561-18.834a8.587,8.587,0,1,1-3.847-7.135l-3.839,3.839a3.356,3.356,0,0,0-.875-.128,3.424,3.424,0,1,0,3.424,3.424,3.356,3.356,0,0,0-.128-.875l3.839-3.839A8.508,8.508,0,0,1,32.854,27.682Zm8.1-12.232-3.318-1.108-1.106-3.32,4.138-4.142L41.5,9.389a1.712,1.712,0,0,0,1.082,1.084l2.507.836Z",
    transform: "translate(146.048 485.999)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectives);
export default __webpack_public_path__ + "static/media/objectives.d6242cee1650707eef2aab8d107766cd.svg";
export { ForwardRef as ReactComponent };